var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8183 22.75H0V0H23.8183V22.75Z",
    fill: "#DD5B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7371 10.2553C13.7371 9.82802 13.6105 9.48776 13.3493 9.23454C13.0882 8.98132 12.6372 8.85471 12.012 8.85471H10.9596V11.6955H12.0041C12.6768 11.6955 13.1436 11.5531 13.3968 11.2761C13.6263 11.0229 13.7371 10.6826 13.7371 10.2553ZM16.5225 10.2237C16.5225 11.1653 16.2851 11.9329 15.8103 12.5501C15.201 13.3493 14.1802 13.745 12.7638 13.745H10.9596V17.3692H8.18213V6.80524H12.7163C14.0061 6.80524 14.9794 7.16132 15.652 7.88141C16.2297 8.49071 16.5225 9.27411 16.5225 10.2316V10.2237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointIcon);
export default __webpack_public_path__ + "static/media/powerpoint_icon.30c60bbb679acb76912a6a69adcc2787.svg";
export { ForwardRef as ReactComponent };